<template>
    <div class="key-takeaways mt-5">
        <div v-if="reloading" class="spinner element-spinner d-flex flex-column justify-content-center align-items-center">
            <span class="spinner-border spinner-border-sm margin-right5" role="status" aria-hidden="true"></span>
        </div>
        <h1 class="section-name col-12 mb-4 text-uppercase">{{takeawaysData.name}}<button v-if="!editTakeaway && getUserPermissions().edit_reports && !isGuest" class="btn btn-secondary" @click="editTakeawayData">Edit</button></h1>
        <div v-if="editTakeaway" class="row justify-content-center my-3" :class="{'not-showing': !showTakeaway}">
        <transition name="fade-edit">
            <div v-if="!isGuest" v-show="showTakeaway" class="col">
                <div class="row mb-5">
                    <div class="col takeaways-wrap" data-takeaway="takeaway1">
                        <h6 class="font-weight-bold my-2">Body 1: </h6>
                        <textarea class="froala-takeaways takeaway_1">{{body_1}}</textarea>
                    </div>
                </div>
                <div class="row mb-5">
                    <div class="col takeaways-wrap" data-takeaway="takeaway2">
                        <h6 class="font-weight-bold my-2">Body 2: </h6>
                        <textarea class="froala-takeaways takeaway_2">{{body_2}}</textarea>
                    </div>
                </div>
                <div class="row mb-5">
                    <div class="col takeaways-wrap" data-takeaway="takeaway3">
                        <h6 class="font-weight-bold my-2">Body 3: </h6>
                        <textarea class="froala-takeaways takeaway_3">{{body_3}}</textarea>
                    </div>
                </div>
                <div class="row mb-5">
                    <div class="col takeaways-wrap" data-takeaway="takeaway4">
                        <h6 class="font-weight-bold my-2">Body 4: </h6>
                        <textarea class="froala-takeaways takeaway_4">{{body_4}}</textarea>
                    </div>
                </div>
                <div class="row">
                    <template v-if="hasArchive">
                        <div class="col">
                            <button class="btn btn-secondary reverse float-right ml-3" @click="closeTakeaway">Close</button>
                            <button class="btn btn-secondary float-right" @click="saveTakeaway">Save</button>
                        </div>
                    </template>
                    <template v-else>
                        <div class="col-md-6">
                            <label class="font-weight-bold">Select a name for the archive: </label>
                            <input v-model="archive_name" type="text" class="archive w-50" name="archive_name" />
                        </div>
                        <div class="col-md-6">
                            <button class="btn btn-secondary reverse float-right ml-3" @click="closeTakeaway">Close</button>
                            <button class="btn btn-secondary float-right" @click="saveTakeaway">Save</button>
                        </div>
                    </template>
                </div>
            </div>
        </transition>
        </div>
        <transition name="fade-takeaways">
            <div v-if="!editTakeaway" class="row highlights justify-content-center my-3">
                <template v-if="errors">
                    <div class="empty-data"><img :src="$store.state.app_url+'/images/errors.gif'"></div>
                </template>
                <template v-else>
                    <div v-for="(takeaway, idx) in takeaways" class="col-12 d-flex flex-column justify-content-center" :class="'col-md-' + num_cols">
                        <div class="fr-text key-wrap flex-grow-1 px-xs-0 pb-xs-0 px-md-5 pb-md-4" :class="'key'+ ++idx">
                            <h1>{{idx}}</h1>
                            <p v-html="takeaway.body" class="ul-wrap">{{takeaway.body}}</p>
                        </div>
                    </div>
                </template>
            </div>
        </transition>
    </div>
</template>

<script>
    export default {
        props: ['isBuilt', 'takeawaysData', 'isGuest', 'hasSkb'],
        created() {
            if(this.isBuilt){
                this.isArchive = this.$store.state.isArchive;
                this.prefixed_id = this.isArchive ? this.takeawaysData.archive_id : this.takeawaysData.report_id;
                this.fetchServerData();
                event_bus.$on('archive_name', (archive_name) => {
                    this.archive_name = archive_name;
                    this.hasArchive = true;
                });
            }
        },
        data() {
            return {
                isArchive:null,
                takeaways:[],
                editTakeaway:false,
                showTakeaway:false,
                num_cols:1,
                body_1:'',
                body_2:'',
                body_3:'',
                body_4:'',
                errors:false,
                hasArchive:false,
                archive_name:null,
                reloading:false
            }
        },
        mounted(){
            event_bus.$on('reloading', () => {
                this.resetData();
                this.fetchServerData();
            });
        },
        methods: {
            resetData(){
                this.body_1 = '';
                this.body_2 = '';
                this.body_3 = '';
                this.body_4 = '';
                this.takeaways = [];
            },
            fetchServerData(){
                if(this.reloading) return;
                this.reloading = true;
                let params = {
                    'isArchive':            this.isArchive,
                    'prefixed_id':          this.prefixed_id,
                    'client_id':            this.takeawaysData.client_id,
                    'element_abbr':         this.takeawaysData.element_abbreviation,
                    'dwm':                  this.$store.state.current_dwm,
                    'date_from':            this.$store.state.current_dates.date_from,
                    'date_to':              this.$store.state.current_dates.date_to,
                    'date_compare_from':    this.$store.state.current_dates.date_compare_from,
                    'date_compare_to':      this.$store.state.current_dates.date_compare_to,
                    'element_id':           this.takeawaysData.element_id,
                    'report_element_id':    this.takeawaysData.report_element_id,
                    'element_name':         this.takeawaysData.name
                };

                params = encodeURIComponent(JSON.stringify(params));
                this.takeaways = [];
                if(this.$store.state.isArchive){
                    axios.get(`/api/reporting/takeaways/${this.$route.params.archive_id}/?params=${params}`).then((takeawaysData) => {
                        if(takeawaysData.data){
                            this.hasArchive = takeawaysData.data.hasArchive;
                            this.errors = takeawaysData.data.errors;
                            if(this.hasArchive){
                                this.archive_name = takeawaysData.data.archive_name;
                            }
                            _.each(takeawaysData.data, (takeaway, index) => {
                                if(takeaway.body){
                                    this.takeaways.push(takeaway);
                                }
                                this['body_'+index.substr(-1, 1)] = takeawaysData.data[index]['body'];
                            });
                            this.num_cols = 12/this.takeaways.length;
                        }
                        this.reloading = false;
                    });
                }
                else{
                    axios.get(`/api/reporting/takeaways/${this.$route.params.report_id}/?params=${params}`).then((takeawaysData) => {
                        if(takeawaysData.data){
                            this.hasArchive = takeawaysData.data.hasArchive;
                            this.errors = takeawaysData.data.errors;
                            if(this.hasArchive){
                                this.archive_name = takeawaysData.data.archive_name;
                            }
                            _.each(takeawaysData.data, (takeaway, index) => {
                                if(takeaway.body){
                                    this.takeaways.push(takeaway);
                                }
                                this['body_'+index.substr(-1, 1)] = takeawaysData.data[index]['body'];
                            });
                            this.num_cols = 12/this.takeaways.length;
                        }
                        this.reloading = false;
                    });
                }
            },
            editTakeawayData(){
                const report_element_id = this.takeawaysData.report_element_id;
                let params = {
                    'prefixed_id':          this.prefixed_id,
                    'client_id':            this.takeawaysData.client_id,
                    'element_abbr':         this.takeawaysData.element_abbreviation,
                    'element_id':           this.takeawaysData.element_id,
                    'report_element_id':    this.takeawaysData.report_element_id,
                    'element_name':         this.takeawaysData.name,
                    'date_from':            this.$store.state.current_dates.date_from,
                    'date_to':              this.$store.state.current_dates.date_to,
                    'date_compare_from':    this.$store.state.current_dates.date_compare_from,
                    'date_compare_to':      this.$store.state.current_dates.date_compare_to,
                };
                event_bus.$emit('show_chatGPT', params);
                axios.get(`/api/reporting/tk_need_refresh/${report_element_id}`).then((response) => {
                    if(response.data.success == false){
                        const message = "Something changed in the builder, so you need a page refresh before editing this element."
                        this.notification(message, 'type-warning', 'INFORMATION', BootstrapDialog.SIZE_SMALL, 5000, function(){location.reload()});
                    }
                    else{
                        this.editTakeaway = true;
                        this.openHighligthsFroalaEditor();
                    }
                });
            },
            openHighligthsFroalaEditor(){
                const vueInstance = this;
                setTimeout(function(){
                    $('#reporting_view').find('.froala-takeaways').off('froalaEditor.initialized').froalaEditor({
                        key: 'AA12B9A4A4xC2D2F2B2A29A3C3A8B1D2sg1Ti1LXd2URVJh1DWXG==',
                        height: 200,
                        charCounterCount: false,
                        requestWithCORS: false,
                        htmlExecuteScripts: false,
                        htmlUntouched: true,
                        htmlAllowedTags: ['a', 'abbr', 'address', 'area', 'article', 'aside', 'b', 'base', 'blockquote', 'br', 'button', 'caption', 'cite', 'col', 'colgroup', 'datalist', 'dd', 'del', 'details', 'dfn', 'div', 'dl', 'dt', 'em', 'fieldset', 'figcaption', 'figure', 'footer', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'header', 'hgroup', 'hr', 'i', 'img', 'ins', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'menu', 'menuitem', 'nav', 'ol', 'optgroup', 'p', 'param', 'pre', 'progress', 'queue', 'rp', 'rt', 's', 'section', 'small', 'span', 'strike', 'strong', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'tfoot', 'th', 'thead', 'title', 'tr', 'u', 'ul'],
                        htmlRemoveTags: ['script', 'form', 'style', 'iframe', 'input', 'select', 'option', 'video', 'audio', 'canvas', 'code', 'object', 'keygen'],
                        toolbarButtons: ['bold', 'italic', 'underline', 'strikeThrough', 'subscript', 'superscript', 'fontFamily', 'fontSize', 'color', 'formatOL', 'formatUL', 'insertLink', 'insertTable', 'specialCharacters', 'insertHR', 'selectAll', 'clearFormatting', 'undo', 'redo'],
                        fontFamily: {
                            "Arial, Helvetica, sans-serif": 'Arial',
                            "Georgia, serif": 'Georgia',
                            "Impact, Charcoal, sans-serif": 'Impact',
                            "Tahoma, Geneva, sans-serif": 'Tahoma',
                            "Times New Roman, Times, serif": 'Times New Roman',
                            "Verdana, Geneva, sans-serif": 'Verdana',
                            "BentonSans Regular": 'BentonSans Regular',
                        }
                    });
                    vueInstance.showTakeaway = true;
                }, 400);
            },
            saveTakeaway(){
                let takeaways = {};
                $('#reporting_view').find('div.takeaways-wrap').each(function(idx, el) {
                    const $el = $(el);
                    const body = $el.find('.froala-takeaways').froalaEditor('html.get', true);

                    takeaways[$el.attr('data-takeaway')] = {'body':body};
                });

                const prefixed_id = this.isArchive ? this.$route.params.archive_id : this.$route.params.report_id;
                const report_element_id = this.takeawaysData.report_element_id;

                axios.post(`/api/reporting/takeaways`, {
                    isArchive:              this.isArchive,
                    prefixed_id:            prefixed_id,
                    report_element_id:      report_element_id,
                    client_id:              this.takeawaysData.client_id,
                    date_from:              this.$store.state.current_dates.date_from,
                    date_to:                this.$store.state.current_dates.date_to,
                    date_compare_from:      this.$store.state.current_dates.date_compare_from,
                    date_compare_to:        this.$store.state.current_dates.date_compare_to,
                    takeaways:              takeaways,
                    hasArchive:             this.hasArchive,
                    archive_name:           this.archive_name,
                    hasSkb:                 this.hasSkb
                }).then((response) => {
                    if(response.data['need_refresh']){
                        const message = "This report have been modified in the builder and cannot be saved without losing this text. You will need to open a new version of this report and edit it again."
                        this.notification(message, 'type-warning', 'INFORMATION', BootstrapDialog.SIZE_SMALL, 20000);
                    }
                    else{
                        this.$notify({
                            type: 'success',
                            text: response.data['exists'] == true ? this.messages.HIGHLIGHTS_UPDATED : this.messages.HIGHLIGHTS_CREATED
                        });
                        const takeawaysData = response.data['takeaways'];
                        this.editTakeaway = false;
                        this.showTakeaway = false;
                        this.hasArchive = true;
                        this.takeaways = [];
                        _.each(takeawaysData, (takeaway, index) => {
                            if(takeaway.body){
                                this.takeaways.push(takeaway);
                            }
                            this['body_'+index.substr(-1, 1)] = takeawaysData[index]['body'];
                        });
                        this.num_cols = 12/this.takeaways.length;
                        event_bus.$emit('archive_name', this.archive_name);
                    }
                });
            },
            closeTakeaway(){
                const vueInstance = this;
                this.showTakeaway = false;
                event_bus.$emit('hide_chatGPT', true);
                setTimeout(function(){
                    vueInstance.editTakeaway = false;
                }, 1000);
            }
        }
    }
</script>
<style lang="scss">
    @import '~@/_variables.scss';
    div.key-takeaways{
        span.h-line{
            display:inline-block;
            border-top:0.3rem solid;
            border-bottom:0.3rem solid;
            border-radius:0.6rem;
            width:100%;
        }
        div.not-showing{
            display:none;
        }

        .fade-edit-enter-active{
            transition: opacity 2s;
        }
        .fade-edit-leave-active {
            transition: opacity 1s;
        }
        .fade-edit-enter, .fade-edit-leave-to {
            opacity: 0;
        }
        .fade-takeaways-enter-active{
            transition: opacity 2s;
        }
        .fade-takeaways-leave-active{
            transition: opacity .5s;
        }
        .fade-takeaways-enter, .fade-takeaways-leave-to /* .fade-leave-active до версии 2.1.8 */ {
            opacity: 0;
        }

        div.takeaways{
            font-size:1.8rem;
        }
        div.highlights{
            div.img-wrap{
                img{
                    max-width:100%;
                }
            }
            div.key-wrap{
                border-radius:4rem;
                &.key{
                    border-radius:2rem;
                    border:0.2rem solid $black-blue;
                }
                &.key1{
                    border:0.2rem solid $light-blue;
                }
                &.key2{
                    border:0.2rem solid $black-blue;
                }
                &.key3{
                    border:0.2rem solid $gold;
                }
                &.key4{
                    border:0.2rem solid $dark-orange;
                }
                h1{
                    font-size:6rem;
                }
            }
        }
        p.ul-wrap{
            ul ul{
                @media screen and (max-width: 768px) {
                    padding-left:1rem !important;
                }
            }
        }
    }
</style>
